import React, { useState, useEffect } from 'react';
import { Package, Edit2, PlusCircle, ArrowLeft, Trash2, Wrench, FileDown, ArrowUpDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import api, { API_BASE_URL } from './config';

function TupYonetimi({ user }) {
    const [tupler, setTupler] = useState([]);
    const [firmalar, setFirmalar] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // Filtreleme state'leri
    const [searchSeri, setSearchSeri] = useState('');
    const [searchKonum, setSearchKonum] = useState('');
    const [selectedFirma, setSelectedFirma] = useState('');

    const isMusteriOnly = user?.rol === 'Müşteri';
    const canEdit = user?.rol === 'Admin' || user?.rol === 'User';

    const today = new Date().toISOString().split('T')[0];
    const nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0];

    const [formData, setFormData] = useState({
        firma_id: isMusteriOnly ? user.firma_id : '',
        seri_no: '',
        tüp_tipi: 'KKT',
        ağırlık: 6,
        konum: '',
        son_bakım_tarihi: today,
        bir_sonraki_bakım_tarihi: nextYear
    });

    useEffect(() => {
        fetchTupler();
        if (!isMusteriOnly) fetchFirmalar();
    }, [searchSeri, searchKonum, selectedFirma]);

    const fetchTupler = async () => {
        const firmaId = isMusteriOnly ? user.firma_id : 1;
        const params = {
            search_seri: searchSeri,
            search_konum: searchKonum,
            selected_firma: isMusteriOnly ? user.firma_id : selectedFirma
        };
        const res = await api.get(`/api/tupler/${firmaId}`, { params });
        setTupler(res.data);
    };

    const fetchFirmalar = async () => {
        const res = await api.get('/api/firmalar');
        setFirmalar(res.data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.firma_id) return alert("Lütfen bir firma seçin!");

        const payload = {
            ...formData,
            firma_id: parseInt(formData.firma_id),
            ağırlık: parseFloat(formData.ağırlık)
        };

        try {
            if (editId) {
                await api.put(`/api/tupler/${editId}`, payload);
                alert("Tüp güncellendi!");
            } else {
                await api.post('/api/tupler', payload);
                alert("Tüp eklendi!");
            }
            resetForm();
            fetchTupler();
        } catch (err) {
            console.error(err);
            alert("İşlem başarısız!");
        }
    };

    const resetForm = () => {
        setFormData({
            firma_id: isMusteriOnly ? user.firma_id : '',
            seri_no: '',
            tüp_tipi: 'KKT',
            ağırlık: 6,
            konum: '',
            son_bakım_tarihi: today,
            bir_sonraki_bakım_tarihi: nextYear
        });
        setFormOpen(false);
        setEditId(null);
    };

    const handleEdit = (tup) => {
        setEditId(tup.tüp_id);
        setFormData({
            firma_id: tup.firma_id,
            seri_no: tup.seri_no,
            tüp_tipi: tup.tüp_tipi,
            ağırlık: tup.ağırlık,
            konum: tup.konum,
            son_bakım_tarihi: tup.son_bakım_tarihi || today,
            bir_sonraki_bakım_tarihi: tup.bir_sonraki_bakım_tarihi || nextYear
        });
        setFormOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu tüpü silmek istediğinize emin misiniz?")) return;
        await api.delete(`/api/tupler/${id}`);
        fetchTupler();
    };

    const handleBakim = async (id) => {
        if (!window.confirm("Bu tüp için bakım yapıldı olarak işaretlensin mi?")) return;
        try {
            await api.patch(`/api/tupler/${id}/bakim`);
            alert("Bakım kaydedildi!");
            fetchTupler();
        } catch { alert("İşlem başarısız!"); }
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedTupler = [...tupler].sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';
        if (typeof aVal === 'string') aVal = aVal.toLowerCase();
        if (typeof bVal === 'string') bVal = bVal.toLowerCase();
        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const SortableHeader = ({ label, sortKey }) => (
        <th style={{ ...p12, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort(sortKey)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {label}
                <ArrowUpDown size={14} color={sortConfig.key === sortKey ? '#3b82f6' : '#9ca3af'} />
            </div>
        </th>
    );

    return (
        <div style={{ padding: '20px', backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

                <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '20px', color: '#3b82f6', textDecoration: 'none' }}>
                    <ArrowLeft size={18} /> Ana Sayfa
                </Link>

                <div style={panelStyle}>
                    <h2 style={{ marginTop: 0 }}>
                        <Package size={24} style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                        {isMusteriOnly ? "Firmamın Tüpleri" : "Tüp Yönetimi"}
                    </h2>

                    {/* FİLTRELEME PANELİ */}
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap', padding: '15px', backgroundColor: '#f9fafb', borderRadius: '10px' }}>
                        {!isMusteriOnly && (
                            <div style={{ flex: '1', minWidth: '150px' }}>
                                <label style={labelStyle}>Firma</label>
                                <select value={selectedFirma} onChange={e => setSelectedFirma(e.target.value)} style={inputBase}>
                                    <option value="">Tümü</option>
                                    {firmalar.map(f => <option key={f.firma_id} value={f.firma_id}>{f.firma_adı}</option>)}
                                </select>
                            </div>
                        )}
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Seri No</label>
                            <input
                                type="text"
                                placeholder="Seri no ara..."
                                value={searchSeri}
                                onChange={e => setSearchSeri(e.target.value)}
                                style={inputBase}
                            />
                        </div>
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Konum</label>
                            <input
                                type="text"
                                placeholder="Konum ara..."
                                value={searchKonum}
                                onChange={e => setSearchKonum(e.target.value)}
                                style={inputBase}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
                            <button onClick={() => { setSearchSeri(''); setSearchKonum(''); setSelectedFirma(''); }} style={{ ...saveBtn, backgroundColor: '#6b7280' }}>
                                Temizle
                            </button>
                            <button
                                onClick={() => window.open(`${API_BASE_URL}/api/rapor/tupler?firma_id=${isMusteriOnly ? user.firma_id : (selectedFirma || 0)}`, '_blank')}
                                style={{ ...saveBtn, backgroundColor: '#10b981' }}
                            >
                                <FileDown size={16} style={{ marginRight: '5px' }} /> PDF
                            </button>
                        </div>
                    </div>

                    {/* Müşteri ekleme/düzenleme yapamaz */}
                    {canEdit && (
                        <button onClick={() => { setFormOpen(!formOpen); if (formOpen) resetForm(); }} style={{ ...saveBtn, backgroundColor: '#3b82f6', marginBottom: '20px' }}>
                            <PlusCircle size={18} style={{ marginRight: '8px' }} />
                            {formOpen ? "İptal" : "Yeni Tüp Ekle"}
                        </button>
                    )}

                    {formOpen && canEdit && (
                        <form onSubmit={handleSubmit} style={{ marginBottom: '20px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '12px' }}>
                            <h4 style={{ marginTop: 0 }}>{editId ? "Tüp Düzenle" : "Yeni Tüp"}</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                                <div>
                                    <label style={labelStyle}>Firma</label>
                                    {isMusteriOnly ? (
                                        <input type="text" value="Kendi Firmanız" style={inputBase} disabled />
                                    ) : (
                                        <select value={formData.firma_id} onChange={e => setFormData({ ...formData, firma_id: e.target.value })} style={inputBase} required>
                                            <option value="">Firma Seç...</option>
                                            {firmalar.map(f => <option key={f.firma_id} value={f.firma_id}>{f.firma_adı}</option>)}
                                        </select>
                                    )}
                                </div>
                                <div>
                                    <label style={labelStyle}>Seri No</label>
                                    <input type="text" value={formData.seri_no} onChange={e => setFormData({ ...formData, seri_no: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Tüp Tipi</label>
                                    <select value={formData.tüp_tipi} onChange={e => setFormData({ ...formData, tüp_tipi: e.target.value })} style={inputBase}>
                                        <option value="KKT">KKT</option>
                                        <option value="CO2">CO2</option>
                                        <option value="Köpük">Köpük</option>
                                        <option value="Su">Su</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={labelStyle}>Ağırlık (kg)</label>
                                    <input type="number" step="0.1" value={formData.ağırlık} onChange={e => setFormData({ ...formData, ağırlık: e.target.value })} style={inputBase} />
                                </div>
                                <div>
                                    <label style={labelStyle}>Konum</label>
                                    <input type="text" value={formData.konum} onChange={e => setFormData({ ...formData, konum: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Son Bakım Tarihi</label>
                                    <input type="date" value={formData.son_bakım_tarihi} onChange={e => setFormData({ ...formData, son_bakım_tarihi: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Gelecek Bakım Tarihi</label>
                                    <input type="date" value={formData.bir_sonraki_bakım_tarihi} onChange={e => setFormData({ ...formData, bir_sonraki_bakım_tarihi: e.target.value })} style={inputBase} required />
                                </div>
                            </div>
                            <button type="submit" style={{ ...saveBtn, backgroundColor: editId ? '#f59e0b' : '#10b981', marginTop: '20px' }}>
                                {editId ? "Güncelle" : "Kaydet"}
                            </button>
                        </form>
                    )}

                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>
                                    <SortableHeader label="ID" sortKey="tüp_id" />
                                    {!isMusteriOnly && <SortableHeader label="Firma" sortKey="firma_adı" />}
                                    <SortableHeader label="Seri No" sortKey="seri_no" />
                                    <SortableHeader label="Tüp Tipi" sortKey="tüp_tipi" />
                                    <SortableHeader label="Ağırlık" sortKey="ağırlık" />
                                    <SortableHeader label="Konum" sortKey="konum" />
                                    <SortableHeader label="Son Bakım" sortKey="son_bakım_tarihi" />
                                    <SortableHeader label="Gelecek Bakım" sortKey="bir_sonraki_bakım_tarihi" />
                                    {canEdit && <th style={p12}>İşlemler</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {sortedTupler.map(t => {
                                    const today = new Date();
                                    const bakimTarihi = t.bir_sonraki_bakım_tarihi ? new Date(t.bir_sonraki_bakım_tarihi) : null;
                                    const kalanGun = bakimTarihi ? Math.ceil((bakimTarihi - today) / (1000 * 60 * 60 * 24)) : null;

                                    let rowStyle = { borderBottom: '1px solid #f3f4f6' };
                                    if (kalanGun !== null) {
                                        if (kalanGun < 0) rowStyle = { ...rowStyle, backgroundColor: '#fef2f2' };
                                        else if (kalanGun <= 30) rowStyle = { ...rowStyle, backgroundColor: '#fffbeb' };
                                    }

                                    return (
                                        <tr key={t.tüp_id} style={rowStyle}>
                                            <td style={p12}>{t.tüp_id}</td>
                                            {!isMusteriOnly && <td style={p12}>{t.firma_adı}</td>}
                                            <td style={p12}><strong>{t.seri_no}</strong></td>
                                            <td style={p12}><span style={{ padding: '4px 10px', borderRadius: '12px', backgroundColor: '#dbeafe', fontSize: '12px' }}>{t.tüp_tipi}</span></td>
                                            <td style={p12}>{t.ağırlık} kg</td>
                                            <td style={p12}>{t.konum}</td>
                                            <td style={p12}>{t.son_bakım_tarihi}</td>
                                            <td style={p12}>
                                                {t.bir_sonraki_bakım_tarihi}
                                                {kalanGun !== null && kalanGun < 0 && <span style={{ marginLeft: '8px', color: '#dc2626', fontSize: '11px' }}>⚠️ Gecikmiş</span>}
                                                {kalanGun !== null && kalanGun >= 0 && kalanGun <= 30 && <span style={{ marginLeft: '8px', color: '#d97706', fontSize: '11px' }}>⏰ {kalanGun} gün</span>}
                                            </td>
                                            {canEdit && (
                                                <td style={p12}>
                                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                                        <button onClick={() => handleBakim(t.tüp_id)} style={iconBtn} title="Bakım Yapıldı"><Wrench size={18} color="#10b981" /></button>
                                                        <button onClick={() => handleEdit(t)} style={iconBtn} title="Düzenle"><Edit2 size={18} color="#f59e0b" /></button>
                                                        <button onClick={() => handleDelete(t.tüp_id)} style={{ ...iconBtn, marginLeft: '8px' }} title="Sil"><Trash2 size={18} color="#ef4444" /></button>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const inputBase = { padding: '12px', borderRadius: '8px', border: '1px solid #ddd', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151' };
const saveBtn = { color: 'white', border: 'none', borderRadius: '8px', padding: '12px 20px', cursor: 'pointer', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' };
const iconBtn = { border: 'none', background: 'none', cursor: 'pointer', marginRight: '8px' };
const p12 = { padding: '12px' };

export default TupYonetimi;
